<template>
	<div class="diag-table">
		<table>
			<thead>
				<tr class="level-header">
					<th colspan="2"></th>
					<template v-for="(item, index) in diagnosisData">
						<th :key="`header-${index}`" :colspan="3" class="qualification-header">{{ item.ZZMC }}</th>
					</template>
				</tr>
				<tr class="type-header">
					<th class="item-name" colspan="2" rowspan="2">类型</th>
					<template v-for="(item, index) in diagnosisData">
						<th :key="`subheader1-${index}`" class="existing-header">现有</th>
						<th :key="`subheader2-${index}`" class="standard-header">标准要求</th>
						<th :key="`subheader3-${index}`" class="result-header">结果</th>
					</template>
				</tr>
			</thead>
			<tbody>
				<!-- 动态生成行 -->
				<template v-for="(rowGroup, groupIndex) in groupedRows">
					<template v-for="(rowType, rowIndex) in rowGroup.rows">
						<tr :key="`row-${groupIndex}-${rowIndex}`">
							<!-- 如果资质名称和类型名称相同则合并单元格列 -->
							<template v-if="rowType.ZZMC === rowType.TYPE">
								<td :colspan="rowType.ZZMC === rowType.TYPE ? 2 : 1" :rowspan="rowGroup.rowspan" class="item-type br">
									{{ rowType.TYPE }}
								</td>
							</template>
							<template v-else-if="rowIndex === 0">
								<td :rowspan="rowGroup.rowspan" class="item-name">{{ rowType.ZZMC }}</td>
								<td class="item-type br">{{ rowType.TYPE }}</td>
							</template>
							<template v-else>
								<td class="item-type br">{{ rowType.TYPE }}</td>
							</template>

							<template v-for="(item, colIndex) in diagnosisData">
								<template v-if="getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC)">
									<td :key="`cell-existing-${groupIndex}-${rowIndex}-${colIndex}`" class="existing-value">
										{{ getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC).EXISTING }}
									</td>
									<td :key="`cell-standard-${groupIndex}-${rowIndex}-${colIndex}`" class="standard-value">
										{{ getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC).STANDARD }}
									</td>
									<td
										:key="`cell-result-${groupIndex}-${rowIndex}-${colIndex}`"
										:class="[
											'result-value',
											getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC).WHETHER ? 'success' : 'error'
										]"
									>
										{{ getOptionByType(item.RESULT, rowType.TYPE, rowType.ZZMC).RESULTS }}
									</td>
								</template>
								<template v-else>
									<td :key="`cell-empty1-${groupIndex}-${rowIndex}-${colIndex}`">-</td>
									<td :key="`cell-empty2-${groupIndex}-${rowIndex}-${colIndex}`">-</td>
									<td :key="`cell-empty3-${groupIndex}-${rowIndex}-${colIndex}`">-</td>
								</template>
							</template>
						</tr>
					</template>
				</template>
			</tbody>
		</table>
	</div>
</template>

<script>
	import { getDiagnosisRecordDetail } from '@/api/certTreasure/diagnosis'
	import { ENUM_DIAGNOSIS_TYPE } from '@/enum'

	// 工程监理诊断结果比对
	export default {
		name: 'EngineeringSupervisionDiagnosisResult',
		components: {},
		props: {
			// 诊断记录id
			recordId: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				// 诊断结果数据
				diagnosisData: []
			}
		},
		computed: {
			// 计算需要合并的行数
			groupedRows() {
				const uniqueTypes = this.getUniqueTypes()
				const grouped = {}
				uniqueTypes.forEach(type => {
					if (!grouped[type.ZZMC]) {
						grouped[type.ZZMC] = { rows: [], rowspan: 0 }
					}
					grouped[type.ZZMC].rows.push(type)
					grouped[type.ZZMC].rowspan++
				})
				return Object.values(grouped)
			}
		},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryRecordDetail()
		},
		methods: {
			// 查询诊断结果对比json
			handleQueryRecordDetail() {
				const params = {
					recordId: this.recordId
				}

				getDiagnosisRecordDetail(params).then(response => {
					const { data } = response

					if (data && data.diagnosisInfo) {
						// 诊断类型
						const diagnosisType = data.diagnosisType
						// 诊断类型对应的名称
						let diagnosisTypeName = ''
						// 遍历诊断类型枚举，查找匹配的类型名称
						Object.keys(ENUM_DIAGNOSIS_TYPE).forEach(key => {
							if (diagnosisType.includes(key)) {
								diagnosisTypeName = ENUM_DIAGNOSIS_TYPE[key]
							}
						})
						// 存储报告生成状态
						this.generateState = data.generateState
						const diagnosisResultData = JSON.parse(data.diagnosisInfo)
						// 安许的资质对比结果需要额外处理，在第一层把资质名称添加上
						diagnosisResultData[0].ZZMC = '工程监理企业资质' + '-' + diagnosisTypeName
						diagnosisResultData[0].ZZCODE = '106'
						console.log('diagnosisResultData:', diagnosisResultData)

						this.diagnosisData = diagnosisResultData
					}
				})
			},

			// 获取所有唯一的类型，用于生成表格行
			getUniqueTypes() {
				const types = []
				this.diagnosisData.forEach(item => {
					item.RESULT.forEach(option => {
						// types.add(option.TYPE)
						types.push({
							TYPE: option.TYPE,
							ZZMC: option.ZZMC
						})
					})
				})
				return types
			},

			// 根据类型获取对应的选项
			getOptionByType(options, type, zzmc) {
				return options.find(option => option.TYPE === type && option.ZZMC === zzmc)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../styles/diagnosisTable.scss';
</style>
